export default "__VITE_ASSET__irjmteFQ__"